import * as React from 'react'

import Spinner, {
  SpinnerSize,
} from '~/client/src/shared/components/Spinner/Spinner'

interface ICardListLoadingProps {
  size?: SpinnerSize
}

const CardListLoading: React.FC<ICardListLoadingProps> = ({ size = 'lg' }) => {
  return (
    <div className="tw:flex tw:items-center tw:justify-center tw:flex-1 tw:w-full tw:min-h-[200px] tw:h-full">
      <Spinner size={size} />
    </div>
  )
}

export default CardListLoading
